// extracted by mini-css-extract-plugin
export default {"container":"PQ","productarea":"QQ","btn":"RQ","promowrapper":"SQ","upsellarea":"TQ","subtitle":"UQ","system":"VQ","desc":"WQ","cardswrap":"XQ","cards":"YQ","squareloadingcontainer":"ZQ","squareloading33":"aR"};
    if(module.hot) {
      // 1711394579311
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  